import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confidence-security-page',
  templateUrl: './confidence-security-page.component.html',
  styleUrls: ['./confidence-security-page.component.css']
})
export class ConfidenceSecurityPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
